/**
 * Helpers for drawing-linked document uploads.
 * API rejects checklist_item/deviation complete_upload when drawing_id is set
 * without x/y (drawing_position_missing → 422).
 */

export const hasDrawingPinCoords = (entry) =>
  entry?.drawing_position_x != null &&
  entry?.drawing_position_x !== "" &&
  entry?.drawing_position_y != null &&
  entry?.drawing_position_y !== "";

/**
 * If drawing_id is set without pin coords, strip drawing binding so upload can
 * complete without creating a pin (user cancelled place, or multi-file leftover).
 */
export const stripIncompleteDrawingPin = (entry) => {
  if (!entry || typeof entry !== "object") return entry;
  if (!entry.drawing_id || hasDrawingPinCoords(entry)) return entry;
  return {
    ...entry,
    drawing_id: null,
    drawing_position_x: null,
    drawing_position_y: null,
    drawing_rotation: 0,
    drawing_page: entry.drawing_page ?? null,
    drawing_version_id: null,
    drawing_snapshot_blob: null,
    drawing_snapshot_document_id: entry.drawing_snapshot_document_id ?? null,
  };
};

export const prepareUploadEntries = (files) =>
  (Array.isArray(files) ? files : [])
    .filter((entry) => entry?.file)
    .map(stripIncompleteDrawingPin);

/** True when entry still has drawing_id but missing coords (would 422 on API). */
export const hasIncompleteDrawingPin = (entry) =>
  Boolean(entry?.drawing_id) && !hasDrawingPinCoords(entry);
